import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What happens after I submit the form?',
  answer: 'A Storm coach will reach out to confirm the best starting class or program for you and schedule your trial visit. We help you pick the right starting point before your first day.'
}, {
  question: 'Do I need any experience?',
  answer: 'No. The vast majority of Storm students start with zero martial arts experience — kids, adults and families alike. Beginner-friendly classes are the norm, not the exception.'
}, {
  question: 'What ages do you teach?',
  answer: 'Storm teaches ages 3 and up. Mini Troopers is for ages 3–5, Kids Taekwondo for ages 6+, and adult classes are open to teens through grandparents. Family classes are mixed-age by design.'
}, {
  question: 'What do I wear to my trial class?',
  answer: 'Comfortable athletic clothing — t-shirt, sweatpants or leggings. Bare feet on the mat. No uniform purchase is required to start.'
}, {
  question: 'Is Storm a karate school?',
  answer: 'No. Storm teaches Taekwondo — Olympic-style, World Taekwondo (WT) and Kukkiwon aligned. Many parents search "karate" as a catch-all; the confidence, discipline and skill benefits are the same.'
}, {
  question: 'Where is Storm located?',
  answer: 'Storm Taekwondo is at 24786 Crestview, Farmington Hills, MI 48335 — easy to reach from Novi, Commerce, Walled Lake, Wixom, Livonia, Northville, Waterford and other Southeast Michigan communities.'
}];
export function FreeTrialFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-1514" />;
}